import React from 'react';
import { connect } from 'react-redux';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";

import { Typography, Button } from '@material-ui/core';

import { AppState, IPageState, store, Actions } from '../../appredux';

import CONFIG from '../../cfg/config';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import MailIcon from '@material-ui/icons/Mail';
import CallIcon from '@material-ui/icons/Call';
import HomeIcon from '@material-ui/icons/Home';
import GpsIcon from '@material-ui/icons/GpsFixed';
import SearchIcon from '@material-ui/icons/Search';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MapIcon from '@mui/icons-material/Map';

//import logo from './../logo.png';
import ResponsiveImgMaterialUi from "responsive-img-material-ui";

import { Trans } from 'react-i18next';

import GoogleIcons from './GoogleIcons';
import { fontSelect } from '../../fonts';

interface KontaktProps extends WithStyles<typeof styles> {
    page: IPageState,
    data: Data,
    logo?: any,
    titleSize?: string,
    fontSize?: string,
    iconSize?: string,
    onSzukaj?: () => void,
    googleIcons?: boolean,
    logoUrl: string,
    color: string
}

interface Data {
    title: string;
    email: string;
    phone: string;
    gps: string;
    address: string;
    adressMap: string;
}

class Kontakt extends React.Component<KontaktProps> {
    textTheme = fontSelect(5, 2) as React.CSSProperties;

    openEmail = () => {
        window.open(`mailto:${this.props.data.email}`)
    }
    openPhone = () => {
        window.open(`tel:${this.props.data.phone}`)
    }
    openGoogleMap = () => {
        window.open(this.props.data.adressMap, "_blank")
    }

    render() {
        const classes = this.props.classes;
        const { logoUrl = '', titleSize = "14px", fontSize = "13px", iconSize = "16px" } = this.props;

        const fotoUrl = `${CONFIG.apiURL}/obiekt/image/${CONFIG.hotelID}/th_startowe.jpg`;

        let trybKiosk = CONFIG.hotelKiosk === "1"

        // let ch1 = `${t('przyjazd').length + 2}ch`
        // let ch2 = `${t('wyjazd').length + 2}ch`

        return (
            <>
                {this.props.googleIcons ? (
                    <>
                        <GoogleIcons />
                        <hr style={{ border: "0", borderBottom: "1px solid lavender", marginTop: "0px" }} />
                    </>
                ) : null}

                <Typography variant="h6" component="h2" color="primary" className={`${classes.primary}`} style={{
                    ...this.textTheme, color: "#ec6430", padding: "6px 10px", fontWeight: "bold", fontSize: titleSize, textAlign: "center",
                    //textOverflow: "ellipsis", overflow: "hidden",
                    whiteSpace: "nowrap"
                }}>
                    <span className={classes.icon} style={{color: this.props.color}}><Trans>Contact</Trans></span> {/* {this.props.data.title} */}
                </Typography>
                {/* <CardMedia
          style={{ width: "250px", maxWidth: "100%", height: "140px", margin: "6px auto 16px" }}
          className={classes.media}
          image={this.props.logoUrl}
          
        />   */}
                <div style={{ textAlign: 'center', }}>
                <div style={{ margin: "6px auto 16px", cursor: "pointer", width: "fit-content", lineHeight: "0",
                        border: "5px solid #fff", boxShadow: "2px 2px 3px 2px #e6e6e6", maxWidth: "calc(100% + -12px)", display: "flex" }}>
                    <ResponsiveImgMaterialUi style={{
                         maxWidth: "250px", maxHeight: "160px", minWidth: "100px", boxShadow: "1px 1px 3px 1px rgb(230, 230, 230)",
                    }}
                        xs={this.props.logoUrl}
                        md={this.props.logoUrl}
                        lg={this.props.logoUrl}
                    />
                </div>
                </div>

                {/* <hr style={{ border: "0", borderBottom: this.props.googleIcons ? "1px solid rgba(224, 224, 224, 1)" : "1px solid rgba(170, 170, 170, 1)", }} /> */}
                {/* <div style={{width: "100%", borderBottom: "1px solid rgba(170, 170, 170, 1)"}}></div> */}
                <div className={classes.tableContainer}>
                    <Table>
                        <TableBody>
                            {this.props.onSzukaj ?
                                (
                                    <TableRow >
                                        <TableCell align="left" style={{ minWidth: "61px" }}
                                            className={`${classes.cell} ${classes.cursorPointer}`} onClick={this.props.onSzukaj}>
                                            <Typography variant="h6" component="h2">
                                                <SearchIcon className={`${classes.icon} `} style={{ marginBottom: "-4px", fontSize: iconSize, color: this.props.color }} />
                                                <span className={classes.title} style={{ fontSize: fontSize }} >
                                                    <Trans>Szukaj</Trans>
                                                </span>
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="right" className={classes.valueCell}>
                                            <Typography variant="h6" component="h2" color='primary' style={{ fontSize: fontSize }}>
                                                <a onClick={this.props.onSzukaj} className={`${classes.email} ${classes.icon} ${classes.cursorPointer}`} style={{ ...this.textTheme, fontWeight: "bold", color: this.props.color, marginTop: "2px" }}><Trans>Twoja rezerwacja</Trans></a>
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                ) : null}
                            <TableRow >
                                <TableCell align="left" style={{ minWidth: "61px" }}
                                     className={`${classes.cell} ${classes.cursorPointer}`}  onClick={this.openEmail}>
                                    <Typography variant="h6" component="h2">
                                        <MailIcon className={`${classes.icon} `} style={{ marginBottom: "-4px", fontSize: iconSize, color: this.props.color }} />
                                        <span className={classes.title} style={{ fontSize: fontSize }} >
                                            <Trans>Email</Trans>
                                        </span>
                                    </Typography>
                                </TableCell>
                                <TableCell align="right" className={classes.valueCell}>
                                    <Typography variant="h6" component="h2" color='primary'className={`${classes.icon}`} style={{ ...this.textTheme, fontSize: fontSize, color: this.props.color, marginTop: "2px" }}>
                                        {trybKiosk ? 
                                        this.props.data.email :
                                        <a href={`mailto:${this.props.data.email}`} className={`${classes.email}`} >{this.props.data.email}</a> }
                                    </Typography>
                                </TableCell>
                            </TableRow>
                            <TableRow >
                                <TableCell align="left"
                                     className={`${classes.cell} ${classes.cursorPointer}`} onClick={this.openPhone}>
                                    <Typography variant="h6" component="h2" >
                                        <CallIcon className={`${classes.icon} `} style={{ marginBottom: "-4px", fontSize: iconSize, color: this.props.color }} />
                                        <span className={`${classes.title}`} style={{ fontSize: fontSize,  }}>
                                            <Trans>Phone</Trans>
                                        </span>
                                    </Typography>
                                </TableCell>
                                <TableCell align="right" className={classes.valueCell}>
                                    <Typography variant="h6" component="h2" color='primary' className={`${classes.icon}`} style={{ ...this.textTheme, fontSize: fontSize, color: this.props.color, marginTop: "2px" }}>
                                        {trybKiosk ? 
                                        this.props.data.phone :
                                        <a href={`tel:${this.props.data.phone}`} className={classes.email}>{this.props.data.phone}</a> }
                                    </Typography>
                                </TableCell>
                            </TableRow>
                            <TableRow >
                                <TableCell align="left" style={{ minHeight: "36px", display: "flex", alignItems: "center"}}
                                    className={`${classes.cell} ${classes.cursorPointer}`} onClick={async () => await store.dispatch(Actions.pageState.setShowMap())}>
                                    <Typography variant="h6" component="h2" style={{ lineHeight: "0.9"}}>
                                        <MapIcon className={`${classes.icon} `} style={{ marginBottom: "-4px", fontSize: iconSize, color: this.props.color }} />
                                        <span className={classes.title} style={{ fontSize: fontSize }}>
                                            <Trans>Map</Trans>
                                        </span>
                                    </Typography>
                                </TableCell>
                                <TableCell align="right" className={classes.valueCell} >
                                    <Typography variant="h6" component="h2" color='primary' className={`${classes.icon}`} style={{ ...this.textTheme, fontSize: fontSize, color: this.props.color, marginTop: "2px" }}>
                                        <Button
                                            variant="text"
                                            onClick={async () => await store.dispatch(Actions.pageState.setShowMap())}
                                            className={`${classes.email} ${classes.gpsButton}`}
                                            style={{userSelect: "text"}}
                                        >
                                            {this.props.data.gps}
                                        </Button>
                                    </Typography>
                                </TableCell>
                            </TableRow>
                            <TableRow >
                                <TableCell align="left" style={{ minHeight: "36px", display: "flex", alignItems: "center"}}
                                    className={`${classes.cell} ${classes.cursorPointer}`} onClick={this.openGoogleMap}>
                                    <Typography variant="h6" component="h2" style={{ lineHeight: "0.9"}} >
                                        <LocationOnIcon className={`${classes.icon} `} style={{ marginBottom: "-4px", fontSize: iconSize, color: this.props.color }} />
                                        <span className={classes.title} style={{ fontSize: fontSize }}>
                                            google
                                        </span>
                                    </Typography>
                                </TableCell>
                                <TableCell align="right" className={classes.valueCell}>
                                    <Typography variant="h6" component="h2" color='primary' className={`${classes.icon}`} style={{ ...this.textTheme, fontSize: fontSize, color: this.props.color, marginTop: "2px" }}>
                                        {trybKiosk ? 
                                        this.props.data.address :
                                        <a href={this.props.data.adressMap} target="_blank" rel="noopener noreferrer" className={classes.email}>{this.props.data.address}</a> }
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </div>

                {/* <Typography
            variant="h6" component="h2" color="primary"
            dangerouslySetInnerHTML={{ __html: this.props.page.kontakt[0].info }}
          /> */}
                {/* {logoUrl !== '' ?
          <div className={classes.pictureContainer}>
            <ResponsiveImgMaterialUi style={{ margin: "auto", display: "block", position: "relative", top: "50%", transform: "translateY(-50%)", width: "40%" }}
              xs={this.props.logo}
              md={this.props.logo}
              lg={this.props.logo}
            />
          </div>
          : null} */}
            </>
        )
    }
}

const styles = (theme: Theme) => ({
    email: {
        color: "inherit",
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    },
    primary: {
        //color: "rgb(236, 100, 48)"
        color: "seagreen"
        //color: theme.palette.primary.main,
    },
    secondary: {
        color: "rgb(236, 100, 48)"
        //color: "seagreen"
        //color: theme.palette.primary.main,
    },
    title: {
        marginLeft: "1em",
        //marginRight:"1em",
        fontSize: "13px",
        "@media screen and (max-width: 1300px) and (min-width: 600px) ": {
            marginLeft: "0.5em",
    
        },
    },
    icon: {
        //backgroundColor: theme.palette.background.default
        color: "#5F9EA0"
    },
    text: {
        color: theme.palette.text.primary
    },
    cell: {
        padding: "0px 0px 5px 10px",
        borderBottom: "1px solid lavender",
        color: theme.palette.text.primary
    },

    valueCell: {
        padding: "0px 5px 0px 0px",
        borderBottom: "1px solid lavender",
    },
    tableText: {
        fontSize: "13px"
    },
    pictureContainer: {
        height: "150px",
        position: "relative" as "relative"
    },
    tableContainer: {
        paddingLeft: "10px",
        paddingRight: "10px",

    },
    "@media screen and (max-width: 1300px) and (min-width: 600px) ": {
        tableContainer: {
            paddingLeft: "0px",
            paddingRight: "0px",
    
        },
        cell: {
            padding: "0px 0px 5px 0px",
            borderBottom: "1px solid lavender",
            color: theme.palette.text.primary
        },
    },
    leftGrid: {
        paddingLeft: "15px",
        paddingRight: "15px"
    },
    "@media screen and (max-width: 960px)": {
        leftGrid: {
            paddingLeft: "0px",
            paddingRight: "0px"
        },
    },
    cursorPointer: {
        cursor: 'pointer'
    },
    media: {
        cursor: "pointer",
        border: "5px solid #fff",
        boxShadow: "2px 2px 3px 2px #e6e6e6",
    },
    gpsButton: {
        padding: 0,
        fontSize: '11px',
        lineHeight: '19.2px',
        letterSpacing: '0.09px',
        textAlign: "end" as "end",
        minWidth: "0",
        "&:hover": {
          background: 'none'
        }
      }
});

const mapStateToProps = (state: AppState) => ({
    page: state.pageState
});

export default connect(mapStateToProps)(withStyles(styles)(Kontakt));